var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedBaseTile)?_c('l-tile-layer',{attrs:{"url":_vm.selectedBaseTile.url,"options":{ maxNativeZoom: _vm.maxNativeZoom, updateWhenIdle: false },"attribution":_vm.attribution}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }